import produce from "immer";
import { INotificationsReducer } from "models/.";
import { actionTypes } from "./actions";
import { notificationSorting as defaultSorting } from "constants/sorting";

const initialState: INotificationsReducer = {
  isLoading: false,
  isLoaded: false,
  items: [],
  meta: {
    defaultSorting
  },
  currentItem: null,
  error: null
};

export default (state = initialState, action: any) =>
  // @ts-ignore
  produce(state, draftState => {
    switch (action.type) {
      case actionTypes.GET_NOTIFICATIONS_SUCCESS:
        draftState.items = action.payload;
        draftState.meta = action.meta;
        break;
      case actionTypes.GET_NOTIFICATIONS_FAILURE:
        draftState.error = action.error;
        break;
      case actionTypes.GET_NOTIFICATION_REQUEST:
        draftState.currentItem = null;
        break;
      case actionTypes.GET_NOTIFICATION_SUCCESS:
        draftState.currentItem = action.payload;
        break;
      case actionTypes.GET_NOTIFICATION_FAILURE:
        return {
          ...initialState,
          error: action.error
        };
      case actionTypes.REMOVE_NOTIFICATION_SUCCESS:
        draftState.items = action.payload;
        break;
      case actionTypes.REMOVE_NOTIFICATION_FAILURE:
        draftState.error = action.error;
        break;
    }
  });
